<div class="container-fluid reset-password">
  <div class="row h-100">
    <div class="col-lg-4 offset-lg-4 py-lg-5 py-4">
      <div class="right-section">
        <div class="right-section-content">
          <div class="onboarding-card" [ngClass]="{ 'd-none': hideForm }">
            <div class="text-center">
              <img src={{verifiedImage}} alt="">
              <h1 class="onboarding-card-title my-3">Reset password</h1>
            </div>

            <div class="content">
              <h4 class="text-center lh-base">Enter your email below and we&apos;ll send you a link to reset your password</h4>
              <form [formGroup]="form" action="#" class="onboarding-form needs-validation" novalidate>
                <div>
                  <div class="mb-lg-4 mb-3 has-validation">
                    <label for="exampleInputEmail1" class="text-black font-17 pb-2 text-start">Email</label>

                    <input type="email" maxlength="255" formControlName="email" class="form-control"
                      [ngClass]="{ 'is-invalid': (form.get('email')?.touched && form.get('email')?.errors) }"
                      placeholder="Please enter your e-mail" id="exampleInputEmail1" aria-describedby="emailHelp" required>

                    <div class="invalid-feedback" *ngIf="form.get('email')?.hasError('email') && !form.get('email')?.hasError('pattern')">
                      Invalid e-mail address
                    </div>

                    <div class="invalid-feedback" *ngIf="form.get('email')?.hasError('apiError') && form.get('email')?.touched">
                      {{errorMessage}}
                    </div>

                    <div class="invalid-feedback" *ngIf="form.get('email')?.hasError('required')">E-mail is required</div>

                    <div class="invalid-feedback" *ngIf="form.get('email')?.hasError('pattern')">Please enter a correct e-mail.</div>
                  </div>

                  <button *ngIf="!loader" type="submit" class="btn-outlined bg-black text-white" (click)="resetPassword();
                    trackButtonClick('Send password reset link');">
                    <span>Send password reset link</span>
                  </button>
                  <spinner *ngIf="loader"></spinner>
                </div>
              </form>
            </div>
          </div>

          <div class="onboarding-card" [ngClass]="{ 'd-none': !hideForm }">
              <div class="text-center">
                <img src={{verifiedImage}} alt="">
                <h1 class="onboarding-card-title my-3">Reset password e-mail</h1>
              </div>
            <div class="content">

              <p class="text font-17">
                We sent a password reset link to {{form.get('email')?.value}} please allow up to 5 minutes for the e-mail to arrive.
              </p>

              <hr>

              <p class="text mb-0"> If you are unable to access your account, please contact support&#64;{{vettimesDomain}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
